import { getLoggedIn } from '@hotjar/webapp/domains/common/user-data';
import styled from '@emotion/styled';
import { Text, tokens } from '@hotjar/hotsauce';
import HOTJAR_LOGO from '@hotjar/shared-assets/images/logo-hotjar.svg';

export interface CentralMessageProps {
  pageImg: string;
  pageImgAlt: string;
  pageTitle: string;
  pageDescription: string;
}

const Message = styled.div`
  text-align: center;
  border-radius: 4px;
  margin: 0 auto;
  margin-top: 80px;
  max-width: 550px;
  padding: ${tokens.spacer.x6};
  gap: ${tokens.spacer.x2};
`;

const SessionContent = styled.div`
  position: relative;
  width: 100%;
`;

const SessionContentContainer = styled.div`
  width: 100%;
  padding: 0;
`;

const MessageHeader = styled.div`
  text-align: center;
  padding: ${tokens.spacer.x1} 0 ${tokens.spacer.x1} 0;
  border-bottom: 1px solid ${tokens.color.neutral_100};
`;

const MessageLogo = styled.img`
  width: 74px;
  height: 36px;
  background-size: 74px;
  margin: 0 auto;
`;

const MessageImg = styled.img`
  margin-bottom: ${tokens.spacer.x2pt5};
`;

export const CentralMessage = (props: CentralMessageProps): JSX.Element => {
  const isLoggedIn = getLoggedIn();
  const { pageImg, pageTitle, pageDescription, pageImgAlt } = props;
  return (
    <SessionContent>
      <SessionContentContainer>
        {!isLoggedIn && (
          <MessageHeader>
            <MessageLogo alt="" src={HOTJAR_LOGO} />
          </MessageHeader>
        )}

        <Message>
          {!!pageImg && <MessageImg alt={pageImgAlt} src={pageImg} />}
          <Text as="h2" textType="header2" textColor="text_light">
            {pageTitle}
          </Text>
          <Text as="p" textType="subtitle1" textColor="text_light">
            {pageDescription}
          </Text>
        </Message>
      </SessionContentContainer>
    </SessionContent>
  );
};
